// extracted by mini-css-extract-plugin
export var mecontrolPlaceHolderStyle = "mKu9B";